/**
 * Shared approval status badge styling for remittance upload history table
 * and seller DRAFT review page. Use the same classes so badges look identical.
 * All badges use white text for visibility on dark table backgrounds.
 */
export type RemittanceUploadStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export const APPROVAL_BADGE_BASE_CLASSES = 'rounded px-2 py-0.5 text-sm font-medium';

export const APPROVAL_BADGE_STYLES: Record<
  RemittanceUploadStatus,
  { colorClass: string; textColor: string }
> = {
  PENDING: { colorClass: '!bg-amber-500', textColor: '!text-white' },
  APPROVED: { colorClass: '!bg-green-600', textColor: '!text-white' },
  REJECTED: { colorClass: '!bg-red-600', textColor: '!text-white' },
};

/** Labels for approval status (upload history table and seller review page). */
export const APPROVAL_LABELS_TABLE: Record<RemittanceUploadStatus, string> = {
  PENDING: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

/** Alias so review page can use same labels as table. */
export const APPROVAL_LABELS_REVIEW = APPROVAL_LABELS_TABLE;

export function getApprovalBadgeClassName(status: RemittanceUploadStatus): string {
  const style = APPROVAL_BADGE_STYLES[status];
  return `${APPROVAL_BADGE_BASE_CLASSES} ${style.colorClass} ${style.textColor}`.trim();
}
